import { SLINKY } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import UICollapser from 'UIComponents/layout/UICollapser';
import styled from 'styled-components';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import { getClickToCopyTicketNumber } from '../constants/events';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SeparatorStyleWrapper = styled.span.withConfig({
  displayName: "TicketInformation__SeparatorStyleWrapper",
  componentId: "sc-1e0ccmx-0"
})(["margin:0 8px;"]);
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "TicketInformation__StyledFormattedMessage",
  componentId: "sc-1e0ccmx-1"
})(["padding-right:4px;"]);
const OpenTicketInformation = ({
  createDate,
  textColor
}) => {
  return /*#__PURE__*/_jsx("span", {
    style: {
      whiteSpace: 'nowrap',
      color: textColor
    },
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-header.openLabel",
      options: {
        duration: /*#__PURE__*/_jsx(FormattedDuration, {
          from: parseInt(createDate, 10),
          to: null
        })
      }
    })
  });
};
const ClosedTicketInformation = ({
  closeDate,
  textColor
}) => {
  return /*#__PURE__*/_jsxs("span", {
    style: {
      whiteSpace: 'nowrap',
      color: textColor
    },
    children: [/*#__PURE__*/_jsx(StyledFormattedMessage, {
      message: "svh-workspace-ui-lib.ticket-header.closedLabel"
    }), /*#__PURE__*/_jsx(FormattedDateTime, {
      value: parseInt(closeDate, 10),
      format: "ll"
    })]
  });
};
const CollapsedInformation = ({
  createDate,
  closeDate,
  textColor
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(SeparatorStyleWrapper, {
      style: {
        color: textColor
      },
      children: '•'
    }), closeDate ? /*#__PURE__*/_jsx(ClosedTicketInformation, {
      closeDate: closeDate,
      textColor: textColor
    }) : /*#__PURE__*/_jsx(OpenTicketInformation, {
      createDate: createDate,
      textColor: textColor
    })]
  });
};
const TicketInformation = ({
  ticketId,
  createDate,
  closeDate,
  trackEvent,
  textColor,
  iconColor
}) => {
  return /*#__PURE__*/_jsx(UIBox, {
    className: "width-100",
    children: /*#__PURE__*/_jsxs(UICollapser, {
      fallback: /*#__PURE__*/_jsx(CollapsedInformation, {
        createDate: createDate,
        closeDate: closeDate,
        textColor: textColor
      }),
      children: [/*#__PURE__*/_jsx(SeparatorStyleWrapper, {
        style: {
          color: textColor
        },
        children: '•'
      }), /*#__PURE__*/_jsxs(UICopyButton, {
        hint: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.ticket-header.copyButtonHint"
        }),
        hintSuccess: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.ticket-header.copyButtonSuccess"
        }),
        tooltipPlacement: "right",
        use: "unstyled",
        value: ticketId,
        style: {
          marginRight: '0rem',
          color: iconColor || SLINKY
        },
        onClick: () => trackEvent(getClickToCopyTicketNumber()),
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            color: textColor
          },
          children: '#'
        }), /*#__PURE__*/_jsx("span", {
          style: {
            color: textColor
          },
          children: ticketId
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "duplicate"
        })]
      }), /*#__PURE__*/_jsx(CollapsedInformation, {
        createDate: createDate,
        closeDate: closeDate,
        textColor: textColor
      })]
    })
  });
};
TicketInformation.displayName = 'TicketInformation';
CollapsedInformation.displayName = 'CollapsedInformation';
OpenTicketInformation.displayName = 'OpenTicketInformation';
ClosedTicketInformation.displayName = 'ClosedTicketInformation';
export default TicketInformation;